import React from "react";
import { Button, Stack } from "@mui/material";
import { ServerPaginatedTable, Loader } from "../../../shared";
import InputControl from "../../../shared/components/InputControl";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import { sortItems } from "../../../utils";

export const UsageHistory = (prop) => {
  const {
    state,
    onChangeusageHistoryFilter,
    resetusageHistoryFilters,
    gotoPageUsageHistory,
    setPageSizeUsageHistory,
    handleSortUsageHistory,
    isBirthdayCoupon = false,
  } = prop;
  const navigate = useNavigate();
  const columns = React.useMemo(
    () => [
      {
        Header: "Coupon Code",
        accessor: "barcode",
      },
      {
        Header: "Used Date & Time",
        accessor: "order_date",
      },
      {
        Header: "Customer Name",
        accessor: "customer_name",
        Cell: ({ row }) => {
          return (
            <Stack direction="row" gap="12px" alignItems="center">
              {row.original.customer_id === null ? (
                row.original.customer_name
              ) : (
                <div
                  className="table-taxt-and-icon-link cursor"
                  onClick={() =>
                    navigate(`/customers/details/${row.original.customer_id}`)
                  }
                >
                  <span className="link-text">
                    {row.original.customer_name}
                  </span>
                </div>
              )}
            </Stack>
          );
        },

        sortType: (prev, curr, columnId) => {
          return sortItems(prev, curr, columnId);
        },
      },
      {
        Header: "Order Id",
        accessor: "order_number",
        Cell: ({ row }) => {
          return (
            <Stack direction="row" gap="12px" alignItems="center">
              <div
                className="table-taxt-and-icon-link cursor"
                onClick={() =>
                  navigate(`/orders/details/${row.original.order_id}`)
                }
              >
                <span className="link-text">{row.original.order_number}</span>
              </div>
            </Stack>
          );
        },

        sortType: (prev, curr, columnId) => {
          return sortItems(prev, curr, columnId);
        },
      },
    ],
    [isBirthdayCoupon, navigate],
  );

  return (
    <>
      {state.isBusy ? (
        <Loader />
      ) : (
        <ServerPaginatedTable
          rowsSelection={false}
          columns={columns}
          data={state?.usageHistory?.data}
          isLoading={state.isBusy}
          gotoPage={gotoPageUsageHistory}
          setPageSize={setPageSizeUsageHistory}
          pagination={state.usageHistory.pagination}
          sortByGlobal={state.usageHistory.sortBy}
          handleSort={handleSortUsageHistory}
          defaultSearch={false}
          searchBar={true}
          filterContent={
            <InputControl
              type="table-search"
              name="searchText"
              placeholder="Search"
              size="small"
              value={state.usageHistoryfilters.searchText}
              onChange={(e) => onChangeusageHistoryFilter(e)}
              onClear={() => resetusageHistoryFilters()}
            />
          }
        />
      )}
    </>
  );
};
